import m from 'mithril';
import './MaterialDesignComponents.scss';

type SvgIconType = "back_arrow" |"arrow_forward" | "keyboard_arrow_left" | "keyboard_arrow_right" | "calendar" | "menu" | "search" | 
"edit" | "expand_more" | "expand_less" | "language" |
"add_box" | "close" |"restore" | "add" | "remove" | "image" | "photo_size_select_actual" | "radio_button_unchecked" |
"radio_button_checked" | "location_city"| "zoom_out_map"| "warning"| "near_me" | "meeting_room"| "filter_list"| "check_box"| "check_box_outline_blank"|
"import_export" | "email" | "more_vert" | "bed"| "info" | "add_person" | "person" | "menu_2"| "star"| "account_circle";

const supportedIconTypes = {
    back_arrow : "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z",
    arrow_forward : "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z",
    keyboard_arrow_left: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z",
    keyboard_arrow_right: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z",
    menu: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z",
    calendar: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z",
    edit: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z",
    search: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
    expand_more: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z",
    expand_less: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z",
    language: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z",
    add_box: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z",
    close: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
    restore: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z",
    add: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z",
    remove: "M19 13H5v-2h14v2z",
    image: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z",
    photo_size_select_actual: "M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z",
    radio_button_unchecked: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
    radio_button_checked: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
    location_city: "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z",
    warning: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
    zoom_out_map: "M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z",
    near_me: "M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z",
    meeting_room: "M14 6v15H3v-2h2V3h9v1h5v15h2v2h-4V6h-3zm-4 5v2h2v-2h-2z",
    filter_list: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z",
    check_box: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
    check_box_outline_blank: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z",
    import_export: "M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z",
    email: "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 4.99L4 6h16zm0 12H4V8l8 5 8-5v10z",
    more_vert: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
    bed: "M21 10.78V8c0-1.65-1.35-3-3-3h-4c-.77 0-1.47.3-2 .78-.53-.48-1.23-.78-2-.78H6C4.35 5 3 6.35 3 8v2.78c-.61.55-1 1.34-1 2.22v6h2v-2h16v2h2v-6c0-.88-.39-1.67-1-2.22zM14 7h4c.55 0 1 .45 1 1v2h-6V8c0-.55.45-1 1-1zM5 8c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v2H5V8zm-1 7v-2c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v2H4z",
    info: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z",
    add_person: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H9zm-3-3v-3h3v-2H6V7H4v3H1v2h3v3z",
    person: "M11 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM5 18c.2-.63 2.57-1.68 4.96-1.94l2.04-2c-.39-.04-.68-.06-1-.06-2.67 0-8 1.34-8 4v2h9l-2-2H5zm15.6-5.5l-5.13 5.17-2.07-2.08L12 17l3.47 3.5L22 13.91z",
    menu_2: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z",
    star: "M12,8.89L12.94,12h2.82l-2.27,1.62l0.93,3.01L12,14.79l-2.42,1.84l0.93-3.01L8.24,12h2.82L12,8.89 M12,2l-2.42,8H2 l6.17,4.41L5.83,22L12,17.31L18.18,22l-2.35-7.59L22,10h-7.58L12,2L12,2z",
    account_circle: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20z"
};

type SizeScheme = "small" | "medium" | "large"| "largest"; 
const supportedSizeTypes = {
    small: 16,
    medium: 24,
    large: 32,
    largest: 64
};

type ColorScheme = "primary" | "secondary" | "success" | "warning" | "info" | "danger" | "accent" | "muted" | "secondary-dark" | "white-dark";

var SvgIcon:m.Component<{ 
        iconType:SvgIconType, 
        color?:string,
        sizeScheme?:SizeScheme,
        colorScheme?:ColorScheme 
    }> = {            
    view : function({attrs}) {
        let fillColor = attrs.color!=null? attrs.color : "white";        
        let typeContent = supportedIconTypes[attrs.iconType];   
        let sizeValue = 24;
        if(attrs.sizeScheme!=null) {
            sizeValue = supportedSizeTypes[attrs.sizeScheme];
        }        
        let className = (attrs.colorScheme!=null)? "svg-" + attrs.colorScheme : "white-dark";
        
        return m('svg', { 
            class: className,
            width: sizeValue, 
            height: sizeValue, 
            viewBox:"0 0 24 24" },                        
            (attrs.colorScheme != null)? 
            m('path', {d:typeContent}) :
            m('path', {
                d: typeContent,
                fill: fillColor
            })                      
        )
    }
}

interface ActionItemDescriptor {
    iconType?: SvgIconType,
    label?: string|null,
    clickable?: boolean,
    onclick: () => void;
}

function RadioButton() : m.Component<{
    sizeScheme?:SizeScheme,
    colorScheme?:ColorScheme,
    checked: boolean,
    onChange : (checked:boolean) => void 
}> {
    let isChecked = false;
    return {
        oninit(vnode) {
            if(vnode.attrs.checked == true) {
                isChecked = vnode.attrs.checked;
            } 
        },
        view(vnode) {
            return m("div", {
                class: "d-flex align-items-center",
                style: {
                    cursor: 'pointer'
                },
                onclick: () => {isChecked = !isChecked;}
            },
                [
                    m(SvgIcon, {
                        iconType: isChecked? 'radio_button_checked' : 'radio_button_unchecked', 
                        colorScheme: vnode.attrs.colorScheme}),
                    m("span", {class:"ml-1 align-middle"}, "Check Me")
                ]
            )
        }
    }
}

function Button() : m.Component<{onClick?: () => void}> {
    return {
        view(vnode) {
            return m("button", {
                class:"btn btn-success mmd-ripple shadow-sm",
                onclick: (event:any) => {
                    if(vnode.attrs.onClick != null) {
                        vnode.attrs.onClick();
                    }
                }
            }, vnode.children)
        }
    }
}

function Card() : m.Component<{}> {
    return {
        view(vnode) {
            return m("div", {class:"card mmd-ripple mmd-ripple-dark", href:"#", onclick: (e)=> {}  }, 
                m("div.card-body", vnode.children)
            )
        }
    }
}

function NavBarAction() : m.Component<{actionItem:ActionItemDescriptor}> {
    return {
        view({attrs}) {
            return m("div.ml-0", {
                id: "back-btn",
                class:(attrs.actionItem.clickable == undefined || attrs.actionItem.clickable)? "mmd-action-item mmd-ripple d-flex align-items-center justify-content-center": "mmd-item d-flex align-items-center justify-content-center",
                onclick: (event) => {
                    attrs.actionItem.onclick();
                }
            },
                (attrs.actionItem.label!=null) ?
                m("span", attrs.actionItem.label) :
                (attrs.actionItem.iconType != null)?
                m(SvgIcon, {
                    iconType:attrs.actionItem.iconType,
                    color: "white-dark"
                }): m("span", "--")
            );
        }
    }
}

interface DropdownMenuActionDescriptor {
    imgUrl?:string,
    iconType?: SvgIconType,
    label?: string|null,
    items: MenuItemDescriptor[]
}

interface MenuItemDescriptor {
    iconType?: SvgIconType,
    label?: string|null,
    onclick: () => void;
}

export function DropdownMenuAction(): m.Component<{
    dropdownMenuAction:DropdownMenuActionDescriptor,
    hasLogo: boolean
}> {
    let dropdownDialog: Element | any | null = null;
    return {
        oncreate(vnode) {
            dropdownDialog = vnode.dom.querySelector(".navbar-dropdown-dialog")
            if (dropdownDialog != null) {
                dropdownDialog.addEventListener('click', (event: any) => {
                    let rect = event.target.getBoundingClientRect() as any;
                    if (rect.left > event.clientX ||
                        rect.right < event.clientX ||
                        rect.top > event.clientY ||
                        rect.bottom < event.clientY
                    ) {
                        dropdownDialog?.close();
                    }
                });
            }
        },
        view({attrs}) {
            return m("div.pr-2", [
                m("span", 
                    {
                        onclick: () =>{
                            if (dropdownDialog != null) {
                                dropdownDialog.style.left = "12px";
                                dropdownDialog.style.top = (attrs.hasLogo)? "50px":"35px";
                                dropdownDialog.showModal();
                            }
                        }
                    }, 
                    (attrs.dropdownMenuAction.iconType != null)?
                    m(SvgIcon, {
                        iconType:attrs.dropdownMenuAction.iconType,
                        color: "white-dark"
                    }):null,

                    (attrs.dropdownMenuAction.imgUrl != null)?
                    m("img", {src: attrs.dropdownMenuAction.imgUrl}):null
                ),
    
                m("dialog.navbar-dropdown-dialog",
                    m("div.list-group",
                        attrs.dropdownMenuAction.items.map(item =>
                            m("button.list-group-item list-group-item-action", {
                                onclick: (event) => {
                                    console.log("nav menu clicked : ", item)
                                    event.preventDefault();
                                    item.onclick();
                                    if (dropdownDialog) {
                                        dropdownDialog?.close();
                                    }
                                }
                            }, (item.label != null)? m.trust(item.label): item.label)
                        )
                    )
                )
            ]) 
        }
    }
}

function NavBar() : m.Component<{
    title:string,
    subtitle?:string,
    logoUrl?:string|null,
    actionItems?: ActionItemDescriptor[],
    dropdownLanguageAction?:DropdownMenuActionDescriptor,
    dropdownMenuAction?: DropdownMenuActionDescriptor,
    onBackPressed? : () => void,
    canBackPress?: boolean
}> {    
    return {
        view(vnode) {
            let attrs = vnode.attrs;
            return m("div.sticky-top",
                [

                    m('div', {class:"mmd-appbar d-flex flex-row align-items-center py-2 shadow"},
                        [
                            m("div.ml-2", {
                                    class:'mr-auto d-flex flex-row align-items-center'
                                },                         
                                [
                                    (attrs.canBackPress)?
                                    m(NavBarAction, {
                                        actionItem : {
                                            iconType : "back_arrow",
                                            onclick : () => {
                                                if(attrs.onBackPressed != null) {
                                                    attrs.onBackPressed();
                                                } else {
                                                    console.warn("onBackPressed is not defined.");
                                                }
                                            }
                                        }
                                    }) : null,

                                    (attrs.logoUrl != null)?
                                    m("div", {class:(attrs.canBackPress)? "d-flex align-items-center justify-content-center": "d-flex align-items-center justify-content-center ml-2"}, 
                                        m("img", {
                                            src: attrs.logoUrl,
                                            style: {
                                                height: "36px"
                                            }
                                        })
                                    ):null,


                                    //m(SvgIcon, {iconType:"backarrow", color:"white"}),

                                    (attrs.logoUrl == null)?
                                    m("div", {class:"d-flex align-items-center justify-content-center"}, 
                                        m("div", [
                                            m("div.mmd-appbar-title", attrs.title),
                                            (attrs.subtitle != null)? 
                                            m("div.mmd-appbar-subtitle", attrs.subtitle) : null
                                        ])
                                    ): null
                                ]
                            ),

                            (attrs.dropdownLanguageAction != null)?
                            m(DropdownMenuAction, {
                                dropdownMenuAction: attrs.dropdownLanguageAction,
                                hasLogo: attrs.logoUrl != null
                            }):null,
                            
                            (attrs.actionItems != null)?
                            attrs.actionItems.map(actionItem => {
                                return m(NavBarAction, {
                                    actionItem : actionItem
                                })
                            }) : null,

                            (attrs.dropdownMenuAction != null)?
                            m(DropdownMenuAction, {
                                dropdownMenuAction: attrs.dropdownMenuAction,
                                hasLogo: attrs.logoUrl != null
                            }):null
                            
                        ]        
                    ),
 
                    m("div", {class: ""}, vnode.children)
                ]
            )
        }
    }
}

interface SelectionItem {
    label?: string|null,
    onSelected: () => void;
}

function Dialog(): m.Component<{
    title? : string,    
    message? : string,
    isOpen: boolean,
    showCloseIcon?: boolean;
    onClose: () => void,
    actionItems?: ActionItemDescriptor[],
    selectionItems?: SelectionItem[],
    cardColor?: ColorScheme,
    isOnDesktop?:boolean,
    isLocationDialog?:boolean
}> {
    let dialogElem:HTMLDialogElement|null = null;
        
    return {        
        oncreate(vnode) {
            dialogElem = vnode.dom as HTMLDialogElement;
        },
        onupdate: function(vnode) {
            const locationElem = document.getElementById("mmd-dialog-scroll-overflow-lg");
            if(vnode.attrs.isLocationDialog && locationElem != null){
                locationElem.scrollTop = 0;
            }
        },
        onbeforeupdate(vnode) {
            if(dialogElem) {
                if(dialogElem.open) {
                    if(vnode.attrs.isOpen == false) {
                        dialogElem.close();
                    } 
                } else {
                    if(vnode.attrs.isOpen) {
                        dialogElem.showModal();
                    }
                }
            }
        },
        view(vnode) {
            let attrs = vnode.attrs;
            
            return m("dialog", {
                id: "dialog",
                class: "dialog-modal p-0"
            },    
                (attrs.isOpen)?
                m("div.mmd-modal-content-grid1", [
    
                        
                            m("div.card-body ", [ //{class: (attrs.isLocationDialog)? "mmd-dialog-card-adjust-height": "mmd-dialog-card"}, [ 
                                m("div.d-flex justify-content-between", {}, 
                                (   
                                    vnode.attrs.title != null)? 
                                    m("div.lead", {class:"font-weight-bold"}, vnode.attrs.title) : null,
                                   
                                    attrs.showCloseIcon?
                                    m("i.fas.fa-times.clickable.p-2",{
                                            onclick: (event) => {                     
                                                attrs.onClose();
                                            }
                                        }
                                    )
                                    :null
                                ),    
                                
    
                                (vnode.attrs.message != null)?
                                m("div", vnode.attrs.message): null,
                                
                                m("div", {
                                    id: "mmd-dialog-scroll-overflow-lg",
                                    class: (vnode.attrs.isOnDesktop)? "mmd-dialog-scroll-overflow-lg" : "mmd-dialog-scroll-overflow"
                                },
                                    vnode.children
                                )
                            ]), 
                            
                            (vnode.attrs.selectionItems!=null)?
                            m("div", {class:"mmd-dialog-scroll-overflow"},
                                m("div", {class: "list-group list-group-flush"}, 
                                    vnode.attrs.selectionItems.map(item => {
                                        return m("div",
                                            {
                                                class : "list-group-item mmd-ripple mmd-ripple-dark",
                                                onclick: (event) => {
                                                    item.onSelected();
                                                }
                                            }, 
                                            item.label);
                                    })
                                )                        
                            ) : null,
                            
                            (vnode.attrs.actionItems != null)? 
                            m("div.card-footer", {class: "text-right bg-white"},
                                vnode.attrs.actionItems.map(item => {
                                    return m("button", {
                                        class:'btn btn-light text-primary mr-1',
                                        onclick: function(event) {
                                            item.onclick();
                                            //attrs.onClose();
                                        }
                                    }, item.label)
                                })                        
                            ): null
                        
                    
                ]): null
            )
        }
    };
}

function CalendarDialog(): m.Component<{
    title? : string,    
    message? : string,
    isOpen: boolean,
    showCloseIcon?: boolean;
    onClose: () => void,
    actionItems?: ActionItemDescriptor[],
    selectionItems?: SelectionItem[],
    cardColor?: ColorScheme,
    isOnDesktop?:boolean
}> {
    let domElem:Element|null = null;
        
    return {        
        oncreate(vnode) {
            domElem = vnode.dom;
        },

        view(vnode) {
            let attrs = vnode.attrs;
            
            return m("div", {
                class: attrs.isOpen? "mmd-modal mmd-modal-shown" : "mmd-modal mmd-modal-hidden",
                onclick: (event) => {                     
                    if(event.target == domElem) {
                        attrs.onClose();
                    }
                }
            },
                (attrs.isOpen)?
                m("div.card mmd-modal-content", {
                    class: (attrs.cardColor!=null)? 'shadow-lg ' + attrs.cardColor : 'mr-4 shadow-lg',
                    onclick: (event) => {},
                },
                    [
                        m("div.card-body", [ 
                            m("div.d-flex.justify-content-between", {}, 
                            (   
                                vnode.attrs.title != null)? 
                                m("div.lead", {class:"font-weight-bold"}, vnode.attrs.title) : null,
                                
                                attrs.showCloseIcon?
                                m("i.fas.fa-times.clickable.p-2",{
                                        onclick: (event) => {                     
                                            attrs.onClose();
                                        }
                                    }
                                )
                                :null
                            ),    
                            

                            (vnode.attrs.message != null)?
                            m("div", vnode.attrs.message): null,
                            
                            m("div", {
                                class: (vnode.attrs.isOnDesktop)? "mmd-dialog-scroll-overflow-lg" : "mmd-dialog-scroll-overflow"
                            },
                                vnode.children
                            )
                        ]), 
                        
                        (vnode.attrs.selectionItems!=null)?
                        m("div", {class:"mmd-dialog-scroll-overflow"},
                            m("div", {class: "list-group list-group-flush"}, 
                                vnode.attrs.selectionItems.map(item => {
                                    return m("div",
                                        {
                                            class : "list-group-item mmd-ripple mmd-ripple-dark",
                                            onclick: (event) => {
                                                item.onSelected();
                                            }
                                        }, 
                                        item.label);
                                })
                            )                        
                        ) : null,
                        
                        (vnode.attrs.actionItems != null)? 
                        m("div.card-footer", {class: "text-right bg-white"},
                            vnode.attrs.actionItems.map(item => {
                                return m("button", {
                                    class:'btn btn-light text-primary mr-1',
                                    onclick: function(event) {
                                        item.onclick();
                                        //attrs.onClose();
                                    }
                                }, item.label)
                            })                        
                        ): null
                    ]
                ):null
            )
        }
    };
}


export {NavBar, Card, Button, RadioButton, SvgIcon, Dialog, CalendarDialog}


